
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!external_tools.external_content_return_view";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'ExternalTools/ExternalContentReturnView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div class=\"before_external_content_info_alert screenreader-only\" tabindex=\"0\">\n  <div class=\"ic-flash-info\">\n    <div class=\"ic-flash__icon\" aria-hidden=\"true\">\n      <i class=\"icon-info\"></i>\n    </div>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("external_tools.external_content_return_view")
  },data:data},helper ? helper.call(depth0, "The following content is partner provided", options) : helperMissing.call(depth0, "t", "The following content is partner provided", options)))
    + "\n  </div>\n</div>\n<iframe\n  tabindex=\"0\"\n  class=\"tool_launch\"\n  src=\"";
  if (helper = helpers.launch_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.launch_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n  title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "tool_content_2924d18f", "Tool content", options) : helperMissing.call(depth0, "t", "tool_content_2924d18f", "Tool content", options)))
    + "\"\n  allow=\"";
  if (helper = helpers.allowances) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.allowances); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n  data-lti-launch=\"true\"\n>\n</iframe>\n<div class=\"after_external_content_info_alert screenreader-only\" tabindex=\"0\">\n  <div class=\"ic-flash-info\">\n    <div class=\"ic-flash__icon\" aria-hidden=\"true\">\n      <i class=\"icon-info\"></i>\n    </div>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("external_tools.external_content_return_view")
  },data:data},helper ? helper.call(depth0, "The preceding content is partner provided", options) : helperMissing.call(depth0, "t", "The preceding content is partner provided", options)))
    + "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  